import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const PhoneIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_768_88965)">
      <path
        d="M15.1871 19.0283C12.6558 19.0283 9.06208 17.2158 5.74958 14.0908C1.24958 9.77834 -0.656665 4.96585 1.34333 2.84085C1.43708 2.7471 1.56208 2.65335 1.68708 2.59085L4.21833 1.15335C4.87458 0.778345 5.68708 0.965845 6.12458 1.59085L7.96833 4.21585C8.18708 4.52835 8.28083 4.90335 8.18708 5.27835C8.12458 5.6221 7.90583 5.9346 7.59333 6.15335L6.49958 6.8721C7.34333 8.09085 9.62458 11.1221 13.2496 13.2783C13.2808 13.3096 13.3121 13.2783 13.3121 13.2783L14.0933 12.2158C14.5308 11.6221 15.3746 11.4658 16.0308 11.8721L18.7808 13.6221C19.4371 14.0283 19.6246 14.8721 19.2183 15.5283L17.7183 17.9346C17.6246 18.0596 17.5308 18.1846 17.4371 18.2783C16.8746 18.7783 16.0933 19.0283 15.1871 19.0283ZM4.93708 2.3721C4.90583 2.3721 4.93708 2.3721 4.93708 2.3721L2.37458 3.8096C1.18708 5.09085 2.65583 9.18459 6.74958 13.0596C10.9058 16.9971 15.1871 18.4033 16.5621 17.2158L18.0621 14.8096L15.3121 13.0596C15.2808 13.0596 15.2496 13.0596 15.2496 13.0596L14.4683 14.1221C14.0308 14.7158 13.1871 14.8721 12.5621 14.4971C8.65583 12.1533 6.21833 8.90335 5.34333 7.6221C5.12458 7.3096 5.06208 6.9346 5.12458 6.59085C5.18708 6.21585 5.40583 5.90335 5.71833 5.71585L6.81208 4.9971L4.99958 2.40335C4.96833 2.40335 4.93708 2.3721 4.93708 2.3721Z"
        fill="#EEF7FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_768_88965">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default PhoneIconDark;
